import { useState } from 'react';

import { GridSortModel } from '@mui/x-data-grid';

export function usePalmSortModel(
    sortField?: string
) {
    return useState<GridSortModel>([{
        field: sortField ?? 'name',
        sort: 'asc'
    }]);
}
